import { AddCircleRounded } from '@mui/icons-material';
import {
  Box,
  Button,
  FormControlLabel,
  Menu,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { FormikProps } from 'formik';
import { MouseEvent, useMemo, useRef, useState } from 'react';
import { AddFromListFormValues } from './AddProductsFromList';
import { GridColDef } from '@mui/x-data-grid-premium';
import CustomDataGrid from 'src/app/components/CustomDataGrid';

const CreateProductList = ({
  values,
  setFieldValue,
  submitForm,
}: FormikProps<AddFromListFormValues>) => {
  const [menuArchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const handleMenuClose = () => setMenuAnchor(null);
  const addedRowCount = useRef(0);
  const allColumns = ['title', 'description', 'categories'];

  const columns: GridColDef<Record<string, string | number>>[] = useMemo(
    () =>
      values.columns.map((column) => ({
        field: column,
        headerName: column.toLocaleUpperCase(),
        editable: true,
        flex: 1,
      })),
    [values.columns]
  );

  const handleAddRow = () => {
    addedRowCount.current = ++addedRowCount.current;
    setFieldValue('products', [
      ...values.products,
      { sku: '', price: '', index: addedRowCount.current },
    ]);
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Typography variant="h5">
          Manually enter or use a Barcode Scanner to add items to the table
          below
        </Typography>
        <Button
          startIcon={<AddCircleRounded />}
          onClick={(event: MouseEvent<HTMLButtonElement>) => {
            setMenuAnchor(event.currentTarget);
          }}
        >
          Manage Columns
        </Button>
        <Menu
          anchorEl={menuArchor}
          open={!!menuArchor}
          onClose={handleMenuClose}
        >
          <Stack m={1}>
            {allColumns.map((column) => (
              <FormControlLabel
                label={column}
                key={column}
                sx={{ textTransform: 'capitalize' }}
                control={
                  <Switch
                    checked={values.columns.includes(column)}
                    onChange={(event) => {
                      if (event.target.checked)
                        setFieldValue('columns', [...values.columns, column]);
                      else
                        setFieldValue(
                          'columns',
                          values.columns.filter(
                            (existingColumn) => existingColumn !== column
                          )
                        );
                    }}
                    sx={{ m: 1 }}
                  />
                }
              />
            ))}
          </Stack>
        </Menu>
      </Stack>
      <Box minWidth="100%">
        <CustomDataGrid
          rows={values.products}
          columns={columns}
          getRowId={(row) => row.index}
          hideFooter
          onCellEditStop={({ id, row, field, api }) => {
            setFieldValue(
              `products[${row.index}][${field}]`,
              api.getRowWithUpdatedValues(id, field)[field]
            );
          }}
        />
        <Button onClick={handleAddRow}>Add Product</Button>
      </Box>
      <Box alignSelf="flex-end">
        <Button
          variant="flat"
          onClick={() => {
            submitForm();
            setFieldValue('activeStep', 1);
          }}
        >
          Add Products
        </Button>
      </Box>
      {/* <pre>{JSON.stringify(values.products, null, 1)}</pre> */}
    </>
  );
};

export default CreateProductList;
